module.exports = __webpack_public_path__ + "img/srm_saargametkns.31202d8.png";